import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';
function callable(name,m){return !!g[name]&&typeof g[name][m]==='function';}
function inspect(){
  const defs=[
    ['providerRuntime','ZooInvestProviderToResearchRuntimeBridge','create'],
    ['canonicalSEC','ZooInvestSECCanonicalFinancialSnapshot','buildSnapshot'],
    ['financialHealthBridge','ZooInvestSECFinancialHealthInputBridge','toFinancialHealthBridge'],
    ['financialHistory','ZooInvestSECFinancialHistoryEngine','build'],
    ['trajectoryBridge','ZooInvestSECGrowthTrajectoryInputBridge','build'],
    ['companyPackage','ZooInvestCompanyResearchDataPackage','create'],
    ['researchPipeline','ZooInvestResearchRuntimePipelineOrchestrator','create'],
    ['packagePipelineBridge','ZooInvestCompanyPackageResearchPipelineBridge','create'],
    ['uiAdapter','ZooInvestResearchOutputUIFieldAdapter','build']
  ];
  const capabilities={};
  for(const [key,name,m] of defs) capabilities[key]=Object.freeze({global:name,method:m,callable:callable(name,m)});
  const integrationDebt=Object.freeze([
    Object.freeze({id:'PIPELINE_ENGINE_CONFIGURATION',severity:'HIGH',state:'OPEN',
      detail:'Company data reaches the Research Runtime Pipeline contract, but the bridge does not automatically configure every existing research engine. Missing required engines correctly force REVIEW.'}),
    Object.freeze({id:'FINANCIAL_SCORE_CALIBRATION',severity:'EXPECTED',state:'OPEN',
      detail:'SEC facts are wired while 0–10 Financial Health / Growth scores remain intentionally null until calibrated.'}),
    Object.freeze({id:'MARKET_CANONICALIZATION',severity:'MEDIUM',state:'OPEN',
      detail:'Daily market rows exist, but Price Context metrics are not yet canonically derived.'}),
    Object.freeze({id:'UI_DEMO_RESIDUE',severity:'MEDIUM',state:'PATCHED_V4_02',
      detail:'v4.01 cleared <i> progress bars, while the actual Company Quality bars use <span>. v4.02 clears both representations.'})
  ]);
  const callableCount=Object.values(capabilities).filter(x=>x.callable).length;
  return Object.freeze({
    version:VERSION,status:callableCount===defs.length?'STRUCTURE_PRESENT':'STRUCTURE_INCOMPLETE',
    callableCount,total:defs.length,capabilities:Object.freeze(capabilities),integrationDebt,
    nextPriority:'Configure the existing Research Runtime Pipeline with its real engine set before adding another isolated analysis engine.'
  });
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p}),a=inspect();
  ok('all audited capabilities callable',a.callableCount===a.total);
  ok('structure present',a.status==='STRUCTURE_PRESENT');
  ok('pipeline configuration debt explicit',a.integrationDebt.some(x=>x.id==='PIPELINE_ENGINE_CONFIGURATION'&&x.state==='OPEN'));
  ok('score calibration debt explicit',a.integrationDebt.some(x=>x.id==='FINANCIAL_SCORE_CALIBRATION'&&x.state==='OPEN'));
  ok('market canonicalization debt explicit',a.integrationDebt.some(x=>x.id==='MARKET_CANONICALIZATION'&&x.state==='OPEN'));
  ok('UI residue patched',a.integrationDebt.some(x=>x.id==='UI_DEMO_RESIDUE'&&x.state==='PATCHED_V4_02'));
  ok('integration prioritized',a.nextPriority.includes('Configure'));
  const api={VERSION,inspect};
  ok('no trade signal',!('tradeSignal' in api));
  ok('no capital permission',!('capitalPermission' in api));
  ok('no universal score',!('score' in api));
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
g.ZooInvestIntegrationContractAudit=Object.freeze({VERSION,inspect,selfTest});
})(engineContext);